<!--
 * @Author: zxf
 * @Date: 2022-07-26 22:24:00
 * @LastEditors: zxf
 * @LastEditTime: 2023-07-04 17:05:35
 * @Description: 维保计划批量新增/修改
-->
<template>
  <el-dialog
    v-loading="loading"
    class="o-dialog o-no-modal-bg o-dialog--sm o-dialog--md-80 o-dialog--lg-60 o-dialog--xl-50"
    :title="dlTitle"
    :visible.sync="dialogShow"
    :modal="false"
    :close-on-click-modal="false"
    @close="closeDialog()"
  >
    <el-form
      ref="fd"
      class="c-form"
      :model="fd"
      :rules="fdRules"
      :inline="true"
      label-position="right"
      label-width="110px"
      label-suffix="："
    >
      <el-row
        class="c-form__row"
      >
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="项目名称"
            prop="xmId"
          >
            <el-select
              v-model="fd.xmId"
              class="c-form__select"
              placeholder="请选择"
              clearable
              @change="handleXmChange"
            >
              <el-option
                v-for="(item,index) in xmList"
                :key="index"
                :label="item.xmmc"
                :value="item.xmId"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col
          v-if="dlHtzqShow"
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="合同有效期"
            prop="htyxqZ"
          >
            <span
              v-show="!fd.xmId"
              class="u-text-danger"
            >请选择项目</span>
            <span
              v-show="fd.xmId"
              class="c-form__read"
            >{{ htyxqQ | date('yyyy-MM-dd') }} 至 {{ htyxqZ | date('yyyy-MM-dd') }}</span>
          </el-form-item>
        </el-col>
        <el-col
          v-if="dlBnyfShow"
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="计划名称"
            prop="jhmcYd"
          >
            <span
              v-show="!fd.xmId"
              class="u-text-danger"
            >请选择项目</span>
            <el-checkbox-group
              v-show="fd.xmId"
              v-model="fd.jhmcYd"
              class="c-form__checkbox-group"
            >
              <el-checkbox
                v-for="item in jhmcList"
                :key="item.id"
                class="dev-pDetail"
                :label="item.id"
              >
                {{ item.text }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>

        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="计划类型"
            prop="jhlxDm"
          >
            <span class="c-form__read">{{ jhlxMc }}</span>
          </el-form-item>
        </el-col>

        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="维保人员"
            prop="wbryDmList"
          >
            <select-xm-user
              v-model="fd.wbryDmList"
              role-code="WBRY"
              :show-dept="false"
              multiple
              collapse-tags
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="项目负责人"
            prop="xmfzrDm"
          >
            <select-xm-user
              v-model="fd.xmfzrDm"
              placeholder="请选择项目负责人"
              role-code="FireEngineer"
              :show-dept="false"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="12"
        >
          <el-form-item
            class="c-form__item"
            label="技术负责人"
            prop="jsfzrDm"
          >
            <select-xm-user
              v-model="fd.jsfzrDm"
              placeholder="请选择技术负责人"
              role-code="FireEngineer"
              :show-dept="false"
            />
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="维保内容"
            prop="wbnrJhList"
          >
            <el-checkbox-group
              v-model="fd.wbnrJhList"
              class="c-form__checkbox-group"
            >
              <el-checkbox
                v-for="item in wbnrXmList"
                :key="item.wbnrId"
                class="dev-pDetail"
                :label="item.wbnrId"
              >
                {{ item.wbnrMc }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
        <el-col
          class="c-form__col"
          :span="24"
        >
          <el-form-item
            class="c-form__item"
            label="任务描述"
            prop="rmms"
          >
            <el-input
              v-model="fd.rmms"
              class="c-form__input"
              type="textarea"
              rows="4"
              placeholder="请输入任务描述"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div
      slot="footer"
      class="o-dialog__footer"
    >
      <k-button
        btn-text="保存"
        :auth-type="true"
        type="primary"
        @click="handleSave()"
      />
      <k-button
        btn-text="关闭"
        :auth-type="false"
        @click="closeDialog()"
      />
    </div>
  </el-dialog>
</template>

<script>
import { wbjhService } from './wbjh.service';
// import { xfwbglService } from '../xfwbgl.service';
import { wbxmService } from '../wbxm/wbxm.service';
export default {
  name: 'WbjhBatchUpdateDialog',
  props: {
    dlParams: {
      type: Object,
      default: function () {
        return {};
      }
    }
  },
  data () {
    return {
      loading: false, // 页面loading计划年份
      dialogShow: true, // 模态框dialog显示

      xmList: [], // 客户列表
      jhmcList: [], // 计划名称列表
      wbnrXmList: [], // 维保内容
      jsfzrList: [], // 技术负责人列表
      wbryList: [], // 维保人员列表
      jhlxMc: '月', // 计划类型名称
      htyxqQ: null, // 合同有效期起
      htyxqZ: null, // 合同有效期止

      /* 表单参数 Start */
      fd: {
        xmId: null, // 客户名称
        jhlxDm: 'YD', // 计划类型
        jhnfList: [], // 计划年份
        jhmcYd: [], // 计划名称
        jhsjQz: [], // 计划时间
        wbzq: this.jhlxMc, // 维保周期
        wbryDmList: [], // 维保人员
        xmfzrDm: null, // 项目负责人
        jsfzrDm: null, // 技术负责人
        wbnrJhList: [], // 维保内容
        rwms: '对各系统进行定期维护保养，测试并出具维保报告。' // 任务描述
      },
      /* 表单参数 End */

      /* 表单校验规则 Start */
      fdRules: {
        xmId: [
          this.$HMValidator.required('客户名称')
        ], // 客户名称
        jhlxDm: [
          this.$HMValidator.required('计划类型')
        ], // 计划类型
        jhmcYd: [
          this.$HMValidator.required('计划名称')
        ], // 计划名称
        wbryDmList: [
          this.$HMValidator.required('维保人员')
        ], // 维保人员
        jsfzrDm: [
          this.$HMValidator.required('技术负责人')
        ], // 技术负责人
        xmfzrDm: [
          this.$HMValidator.required('项目负责人')
        ], // 项目负责人
        rmms: [
          this.$HMValidator.required('任务描述')
        ] // 任务描述
      },
      /* 表单校验规则 End */

      dlType: 'bnyf', // 模态框类型，'bnyf': 本年月份,'htzq': 合同期限
      dlBnyfShow: false, // 本年月分显示标志
      dlHtzqShow: false // 合同周期显示标志

    };
  },
  computed: {
    /* 根据模态框类型动态展示标题 */
    dlTitle () {
      return `${this.dlType === 'bnyf' ? '批量添加月计划（按本年月份）' : '批量添加月计划（按合同期限）'}`;
    }
  },
  methods: {
    /**
     * @description: 客户变化处理
     * @return {*}
     */
    async handleXmChange () {
      this.fd.wbnrJhList = [];
      this.fd.wbryDmList = [];
      this.getwbnrXmList(); // 更新维保内容列表

      if (this.dlHtzqShow && this.fd.xmId) {
        // 获取合同有效期
        this.getLastestWbht();
      } else if (this.dlBnyfShow) {
        // 更新计划名称
        this.getJhmcList();
      }
    },
    /**
     * @description: 处理表单数据
     * @return {*}
     */
    handleFdData () {
      this.fd.wbryDmList = this.fd.wbryDmList.join(';');
      // this.fd.wbnrJhList = this.fd.wbnrJhList.join(',');
      var jhmcTmp = [];
      var jhsjTmp = [];
      if (this.dlHtzqShow && this.fd.xmId) return;
      this.fd.jhmcYd.forEach(element => {
        jhmcTmp.push(this.jhmcList[element].name);
        const jhsjQz = {
          jhsjQ: this.jhmcList[element].kssj,
          jhsjZ: this.jhmcList[element].jssj
        };
        jhsjTmp.push(jhsjQz);
      });
      this.fd.jhmcYd = jhmcTmp;
      this.fd.jhsjQz = jhsjTmp;
    },
    /**
     * @description: 页面初始化
     * @return {*}
     */
    async init () {
      const _this = this;
      // _this.getJsfzrList(); // 获取技术负责人列表
      _this.getYxkhList();// 获取合同有效范围内的客户列表
      _this.dlBnyfShow = _this.dlType === 'bnyf';
      _this.dlHtzqShow = !_this.dlBnyfShow;
    },
    /**
     * @description: 获取最新合同信息
     * @return {*}
     */
    getLastestWbht () {
      wbjhService.getWbxmInfo(this.fd.xmId)
        .then(rsp => {
          this.fd.xmId = rsp.data.xmId;
          this.htyxqQ = rsp.data.htyxqQ;
          this.htyxqZ = rsp.data.htyxqZ;

          this.getYxJhmcList();
        })
        .catch(err => {
          console.error('获取客户最新合同信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 获取“有效”客户列表
     * @return {*}
     */
    getYxkhList () {
      wbxmService.getYxxmList()
        .then(rsp => {
          this.xmList = rsp.data;
        })
        .catch(err => {
          console.error('获取合同有效用户列表信息错误！', err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    /**
     * @description: 获取维保人员列表
     * @return {*}
     */
    // getWbryList () {
    //   xfwbglService.getWbryList()
    //     .then(rsp => {
    //       this.wbryList = rsp.data;
    //     })
    //     .catch(err => {
    //       console.error('获取合同有效用户列表信息错误！', err);
    //     })
    //     .finally(() => {
    //       this.loading = false;
    //     });
    // },
    /**
     * @description: 保存操作
     * @param {*}
     * @return {*}
     */
    handleSave () {
      this.$refs.fd.validate((valid) => {
        if (valid) {
          this.loading = true;
          this.handleFdData();
          wbjhService.patchSave(this.fd)
            .then(rsp => {
              this.$alert('批量新增成功！', '提示', {
                confirmButtonText: '确定',
                type: 'success',
                callback: action => {
                }
              });
              this.$emit('closeDialog', '');
              this.$emit('callback');
            })
            .catch(err => {
              console.error('批量新增计划错误！', err);
              this.loading = false;
            });
        }
      });
    },

    /**
     * @description: 获取维保内容列表
     * @return {*}
     */
    getwbnrXmList () {
      const _this = this;
      wbjhService.getWbxmWbnr(this.fd.xmId, 'YD')
        .then(rsp => {
          _this.wbnrXmList = rsp.data;
        })
        .catch(err => {
          console.error('获取维保内容列表信息失败！', err);
        });
    },
    /**
     * 获取有效合同的维保计划信息（计划年份，计划名称，计划起止时间）
     */
    getYxJhmcList () {
      const _this = this;
      // 合同有效期起的月份
      var _monthQ = new Date(this.htyxqQ).getMonth() + 1;
      // 有效合同的时间差
      var _time = this.htyxqZ - this.htyxqQ;
      // 计算时间差有多少个月份
      var _month = (new Date(_time).getFullYear() - 1970) * 12 + new Date(_time).getMonth() + 1;
      // 获取今年年份
      const _year = new Date().getFullYear();
      // 遍历获取有效合同时间段的，计划年份、计划名称、计划起始时间
      for (var _m = _monthQ; _m <= _monthQ + _month; ++_m) {
        const _yearOffset = Math.floor((_m - 1) / 12);
        const _month0 = (_m - 1) % 12;
        const kssj = new Date(_year + _yearOffset, _month0, 1);
        const jssj = new Date(_year + _yearOffset, _month0 + 1, 0);
        _this.fd.jhnfList.push(_year + _yearOffset);
        // _m>12 跨年 计算
        if (_m > 12) {
          var _yearqz = parseInt(_m / 12); // 求（_m）当前月份跟合同有效时间起相差多少年
          var _yearqy = parseInt(_m % 12); // 求跨年的月份 _m = 0 表示12月
          if (_yearqy === 0) _yearqz--;
          var _monthStr = _yearqy === 0 ? '12' : _m - (12 * _yearqz);
          const _jhmc = _year + _yearqz + '年' + (_monthStr) + '月维保';

          _this.fd.jhmcYd.push(_jhmc);
        } else {
          const _jhmc = _year + '年' + (_m) + '月维保';
          _this.fd.jhmcYd.push(_jhmc);
        }
        const jhsjQz = {
          jhsjQ: kssj.getTime(),
          jhsjZ: jssj.getTime()
        };
        _this.fd.jhsjQz.push(jhsjQz);
      }
    },
    /**
     * @description: 获取计划名称列表
     * @return {*}
     */
    getJhmcList () {
      const _this = this;
      _this.jhmcList = [];
      var _month = new Date().getMonth() + 1;
      const _year = new Date().getFullYear();
      var _index = 0;
      for (var _m = _month; _m < 13; ++_m) {
        const kssj = new Date(_year, _m - 1, 1);
        const jssj = new Date(_year, _m, 0);
        _this.fd.jhnfList.push(_year);
        const _jhmc = _year + '年' + (_m) + '月维保';
        _this.jhmcList.push({ id: _index++, text: _m + '月', value: _m - 1, name: _jhmc, kssj: kssj.getTime(), jssj: jssj.getTime() });
      }
    },
    /**
     * @description: 关闭模态框dialog
     * @param {*}
     * @return {*}
     */
    closeDialog () {
      this.$emit('closeDialog', '');
    }
  },
  created () {
    this.dlType = this.dlParams.dlType;
    this.init();
  }
};
</script>
